import { IInvoice } from '../interface/IInvoice';
import { IOffer } from '../interface/IOffer';
import { IOfferPosition } from '../interface/IOfferPosition';
import { IMappedLog } from '../interface/IWorklog';

export function openSidebar() {
  if (typeof window !== 'undefined') {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.setProperty('--SideNavigation-slideIn', '1');
  }
}

export function closeSidebar() {
  if (typeof window !== 'undefined') {
    document.documentElement.style.removeProperty('--SideNavigation-slideIn');
    document.body.style.removeProperty('overflow');
  }
}

export function toggleSidebar() {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    const slideIn = window.getComputedStyle(document.documentElement).getPropertyValue('--SideNavigation-slideIn');
    if (slideIn) {
      closeSidebar();
    } else {
      openSidebar();
    }
  }
}

// time
export const secondsToHms = (seconds: number) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  // return `${hours || 0}h ${minutes || 0}m`;
  return { h: hours, m: minutes };
};
export const getTimeLoggedStringFormat = (seconds: number) => {
  const { h, m } = secondsToHms(seconds);
  return `${h}h ${m}m`;
};

// Function to convert hours to days with two digits after the decimal point
export function hoursToDays(hours: number) {
  return Number((hours / 8).toFixed(2));
}

// Function to convert days to hours with two digits after the decimal point
export function daysToHours(days: number) {
  return Number((days * 8).toFixed(2));
}

export const calculateListPrice = (hoursInvoiced: number, rate: number) => {
  return hoursInvoiced * rate;
};

export const calculateProjectPrice = (hoursInvoiced: number, rate: number, discount: number = 0) => {
  return calculateListPrice(hoursInvoiced, rate) * (discount ? 1 - Number(discount) / 100 : 1);
};

export function calculateInvoicedTotalAmount(invoiceDetails: any, DEV: number, PM: number, discount: number = 0) {
  return invoiceDetails.reduce((sum: number, invoiceDetail: any) => {
    const hoursInvoiced = invoiceDetail.timeInvoiced / 3600; // Convert milliseconds to hours
    let rateMultiplier;
    if (invoiceDetail.rate === 'DEV') {
      rateMultiplier = DEV;
    } else if (invoiceDetail.rate === 'PM') {
      rateMultiplier = PM;
    } else {
      rateMultiplier = 0; // Or handle other rates accordingly
    }
    return sum + calculateProjectPrice(hoursInvoiced, rateMultiplier, discount);
  }, 0);
}

export const calculateNewInvoiceOfferTotalAmount = (offer: IOffer | null, epics: IMappedLog['epics']) => {
  if (!offer) return 0;
  return epics.reduce((total, epic) => {
    const rateValue = offer[epic.rate as keyof IOffer] as number;

    // Sum up the timeInvoiced for the current epic
    const epicTotal = epic.logs.reduce((epicSum, log) => {
      return epicSum + calculateProjectPrice(log.timeInvoiced === 0 ? 0 : log.timeInvoiced / 3600, rateValue, offer.discount);
    }, 0);

    return total + epicTotal;
  }, 0);
};

export const calculateNewInvoiceTotalAmount = (data: IMappedLog[]) => {
  return data.reduce((total, d) => {
    const epicTotal = calculateNewInvoiceOfferTotalAmount(d.offer!, d.epics);
    return total + epicTotal;
  }, 0);
};

export const calculatePositionOpenBudget = (
  positionOfferValue: number,
  invoices: IInvoice[],
  position: number,
  DEV: number,
  PM: number,
  discount: number = 0
) => {
  if (!DEV || !PM) return 0;
  if (invoices.length === 0) return Number(positionOfferValue);
  let positionInvoicedTotalAmount = 0;
  invoices.forEach((invoice: IInvoice) => {
    let i = invoice.invoiceDetails.filter((invDet: any) => {
      return invDet.offerPosition == position;
    });
    positionInvoicedTotalAmount += calculateInvoicedTotalAmount(i, DEV, PM, discount);
  });
  return positionOfferValue - positionInvoicedTotalAmount;
};

export const calculateOpenBudget = (offerValue: number, invoices: IInvoice[], DEV: number, PM: number, discount: number = 0) => {
  if (!offerValue || !DEV || !PM) return 0;
  if (invoices.length === 0) return Number(offerValue);
  let invoicedTotalAmount = 0;
  invoices.forEach((invoice: IInvoice) => {
    invoicedTotalAmount += calculateInvoicedTotalAmount(invoice.invoiceDetails, DEV, PM, discount);
  });
  return offerValue - invoicedTotalAmount;
};

export const calculateOfferPostionsTotalProjectPrice = (offerPositions: Partial<IOfferPosition>[]) => {
  return offerPositions.reduce((accumulator, currentValue) => {
    return accumulator + (Number(currentValue.projectPrice!) || 0);
  }, 0);
};

export function extractNumber(invoiceId: string) {
  return parseInt(invoiceId.split('-')[1], 10);
}

export const deutschNumberFormatter = (x: any) => {
  const number = parseFloat((String(x) || '0').replace(/[^0-9.-]/g, ''));
  if (isNaN(number)) {
    return '';
  }
  const formatter = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formatter.format(number);
};
